import { PlayerProperty, Save, Restore } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { restoreBoolean } from '../../ParseHelper';

type PlayerStateKey = 'botOptIn';
type PlayerDataKeys = 'botOptIn';
export default class BotOptIn implements PlayerProperty<
    PlayerStateKey,
    PlayerDataKeys
> {
    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        return playerEndpointData.botOptIn !== Number(playerStateData.botOptIn);
    }

    public restore(playerEndpointData: IPlayerData): Restore<PlayerStateKey>  {
        return restoreBoolean(playerEndpointData.botOptIn, false);
    }

    public save(playerStateData: IPlayerState): Save<PlayerDataKeys> {
        return {
            botOptIn: Number(playerStateData.botOptIn),
        };
    }
}
